import Queries from "./queries";

export default Queries;